/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFSecReviewPartialYesNoEnum = {
    Yes: 'yes',
    No: 'no',
    Partial: 'partial'
} as const;
export type CRSFSecReviewPartialYesNoEnum = typeof CRSFSecReviewPartialYesNoEnum[keyof typeof CRSFSecReviewPartialYesNoEnum];


export function CRSFSecReviewPartialYesNoEnumFromJSON(json: any): CRSFSecReviewPartialYesNoEnum {
    return CRSFSecReviewPartialYesNoEnumFromJSONTyped(json, false);
}

export function CRSFSecReviewPartialYesNoEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPartialYesNoEnum {
    return json as CRSFSecReviewPartialYesNoEnum;
}

export function CRSFSecReviewPartialYesNoEnumToJSON(value?: CRSFSecReviewPartialYesNoEnum | null): any {
    return value as any;
}

